<template lang="pug">
.cp-top-title
  .bg(:class="topType + '-bg'")
    .content.w
      .title-wrap
        .page-title {{info[topType].title}}
        .page-content {{info[topType].content}}
</template>
<script>
import serverList from '@/views/customer/components/server-list'

export default {
  components: {
    serverList
  },
  props: {
    topType: {
      type: String
    }
  },
  data () {
    return {
      info: {
        core: {
          title: '追求卓越，创新没有终点',
          content: '十年匠心铸剑，独创核心技术，以数智化能力驱动营销新征程',
        },
        apply: {
          title: '多场景多行业解决方案',
          content: '去电全渠道多场景营销自动化平台，为各行各业提供新一代智慧营销解决方案，帮助企业通过数据驱动业务增长',
        },
        customer: {
          title: '全心全意成就客户',
          content: '去电以“尽心竭力帮助客户成功”为服务目标，通过不断优化资源配置、提高服务意识及服务水平，快速响应并满足客户的服务需求，为客户提供专业的伴随式服务',
        },
      }
    }
  },
  computed: {},
  methods: {
    showModal () {
      this.$emit('showModal', true)
    }
  }
}
</script>
<style lang="stylus">
@import 'config'
.cp-top-title
  .apply-bg
    background url('../assets/hangye-bg.png') center / 100% no-repeat
  .core-bg
    background url('../assets/core-bg.jpg') center / 100% no-repeat
  .customer-bg
    background url('../assets/customer-bg.png') center / 100% no-repeat
    background-size: cover;
  .bg
    height 580px
    overflow hidden
    .content
      position relative
      margin-top $topbar-height
      .title-wrap
        width 400px
        padding-top 84px
        margin-left 20px
        .page-title
          font-size 36px
        .page-content
          margin 15px 0px 38px
          font-size 16px
        .btn
          display block
          width 192px
          height 48px
          line-height 48px
          text-align center
          background rgba(22,170,186,1)
          border-radius 5px
          border 1px solid rgba(98,242,255,1)
          color #fff
          cursor pointer
</style>
